import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Input,
    Icon,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import ReduxContacts from "../../../../store/actionreducers/apply_medical/contacts";
import {connect} from 'react-redux';
import _ from 'lodash';

const styles = theme => ({
    root: {},
    formControl: {
        marginBottom: 24
    }
});
const newTrialVipState = {
    id: '',
    visit_address: {address: ''},
    user: {
        id: '',
        name: '',
        nickname: '',
        email: '',
        cell_phone_no: '',
        backup_phone: '',
        birthday: '',
        avatar: {},
    }
};

class ApplyMedicalDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {...newTrialVipState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * After Dialog Open
         */
        if (!prevProps.contactDialog.props.open && this.props.contactDialog.props.open) {
            /**
             * Dialog type: 'edit'
             * Update State
             */
            if (this.props.contactDialog.type === 'edit' &&
                this.props.contactDialog.data &&
                !_.isEqual(this.props.contactDialog.data, prevState)) {
                this.setState({...this.props.contactDialog.data});
            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.contactDialog.type === 'new') {
                this.setState({...this.props.contactDialog.data});
            }
        }
    }

    handleChange = (event) => {
        const newState = {...this.state, user: {...this.state.user, [event.target.name]: event.target.value}};
        newState.user.name = newState.user.family_name + newState.user.given_name;
        if (event.target.name === 'password') newState.trial_vip_password = newState.user.password;
        this.setState(newState);
    };

    closeComposeDialog = () => {
        this.props.contactDialog.type === 'edit' ? this.props.closeEditContactDialog() : this.props.closeNewContactDialog();
    };

    canBeSubmitted() {
        return this.state.user.name.length > 0;
    }


    render() {
        const {classes, contactDialog, openValidateMedicalDialog} = this.props;

        return (
            <Dialog className={classes.root} {...contactDialog.props} onClose={this.closeComposeDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {contactDialog.type === 'new' ? '新的測試會員資料' : '測試會員資料'}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.user.avatar.url}/>
                        {contactDialog.type === 'edit' && (
                            <Typography variant="title" color="inherit" className="pt-8">
                                {this.state.user.name}
                            </Typography>
                        )}
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">star</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth disabled>
                            <InputLabel htmlFor="nickname">執業縣市</InputLabel>
                            <Input id="nickname" name="nickname" value={(this.state.city) ? this.state.city.name : ''}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">phone</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth disabled>
                            <InputLabel htmlFor="cell_phone_no">服務機構</InputLabel>
                            <Input id="cell_phone_no" name="cell_phone_no"
                                   value={(this.state.hospital) ? this.state.hospital.name : this.state.unvalidated_hospital_name}/>
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">email</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth disabled>
                            <InputLabel htmlFor="email">醫師證號</InputLabel>
                            <Input id="email" name="email" value={this.state.certificate_no}/>
                        </FormControl>
                    </div>

                    <DialogActions className="justify-between pl-16">
                        <Typography value={''/* 將 IconButton 向右擠 */}/>
                        <IconButton
                            onClick={() => {
                                console.log(this.state.id);
                                openValidateMedicalDialog(this.state.id);
                                this.closeComposeDialog();
                            }}
                        >
                            <Icon>spellcheck</Icon>
                        </IconButton>
                    </DialogActions>
                </DialogContent>


            </Dialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeEditContactDialog: ReduxContacts.ActionCreator.closeEditContactDialog,
        closeNewContactDialog: ReduxContacts.ActionCreator.closeNewContactDialog,
        openValidateMedicalDialog: ReduxContacts.ActionCreator.openValidateMedicalDialog,
        updateContact: ReduxContacts.ActionCreator.updateContact,
    }, dispatch);
}

function mapStateToProps({applyMedicalsApp}) {
    return {
        contactDialog: applyMedicalsApp.contacts.contactDialog
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(ApplyMedicalDialog));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/medical/ApplyMedicalDialog.js